import { Grid } from "@mui/material";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";

const InfoItem = ({ label, value }) => (
  <MDBox mb={0.5}>
    <MDTypography variant="caption" fontWeight="bold" color="text" textTransform="uppercase">
      {label}:
    </MDTypography>
    <MDTypography variant="body2" fontWeight="regular" color="dark">
      {value || "N/A"}
    </MDTypography>
  </MDBox>
);

const PatientHeader = ({ patient }) => (
  <MDBox p={3} borderRadius="lg" sx={{ backgroundColor: "#f8f9fa", border: "1px solid #e0e0e0" }}>
    <MDTypography variant="h6" fontWeight="medium" mb={2}>Patient Information</MDTypography>
    <Grid container spacing={2}>
      <Grid item xs={12} sm={4}><InfoItem label="Full Name" value={patient?.name} /></Grid>
      <Grid item xs={12} sm={4}><InfoItem label="Patient ID" value={patient?.id} /></Grid>
      <Grid item xs={12} sm={4}><InfoItem label="Age" value={patient?.age} /></Grid>
      <Grid item xs={12} sm={4}>
        <InfoItem label="Birthday" value={patient?.birthdayDate ? new Date(patient.birthdayDate).toLocaleDateString("en-GB") : "N/A"} />
      </Grid>
      <Grid item xs={12} sm={4}><InfoItem label="Phone" value={patient?.number} /></Grid>
      <Grid item xs={12} sm={4}><InfoItem label="Nationality" value={patient?.nationality} /></Grid>
    </Grid>
  </MDBox>
);

export default PatientHeader;